import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useMarkersActions} from '../stores/selectors'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {FilesRoutePayload} from '../page-data/payloads/files'

export type HideCommentMutationResponse = {
  commentDatabaseId: number
  threadId: number
  reason: string
}

/**
 * hides a comment for a specific reason
 */
export function useHideCommentMutation() {
  const {
    pullRequest: {pathName: basePath},
  } = useRoutePayload<FilesRoutePayload>()
  const apiUrl = `${basePath}/page_data/${PageData.hideComment}`
  const {updateThreadComment} = useMarkersActions()

  return useMutation({
    mutationFn: async ({commentDatabaseId, reason}: {commentDatabaseId: number; reason: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          classifier: reason,
          commentId: commentDatabaseId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: HideCommentMutationResponse) => {
      updateThreadComment({
        threadID: data.threadId,
        match: storedComment => storedComment.databaseId === data.commentDatabaseId,
        transform: oldComment => {
          if (oldComment) {
            return {...oldComment, isHidden: true, minimizedReason: data.reason}
          }
        },
      })
    },
  })
}
